<template>
  <gg-loading v-if="this.domain.allowCustomNameservers" :loading="!!!domainPopulated" type="table">
    <div v-if="domainPopulated">
      <gg-card>
        <gg-card-header>
          Nameserver Registration
          <gg-btn color="primary"
                 tile

                 depressed
                 class="mb-2 ml-0 float-right"
                 @click="dialog = true">Add Record</gg-btn>
        </gg-card-header>
        <gg-card-text>

          <v-data-table
            :loading="table_loading"
            :headers="ns_table.headers"
            :items="domain.registered_nameservers"
            :footer-props="{ itemsPerPageOptions: this.pagination }"
          >
            <template v-slot:item.actions="{ item }">
              <gg-btn text :loading="buttons.validate" @click="hostValidate(item.hostname)">Validate</gg-btn>
              <gg-btn text @click="hostEdit(item)">Edit</gg-btn>
              <gg-btn text @click="openDeleteModal(item.hostname)">Delete</gg-btn>
            </template>
          </v-data-table>

          <gg-modal :is-active="dialog" @close="closeModal">
            <template v-slot:toolbar>
              Host Record Editor
            </template>
            <template v-slot:body>
              <v-row>
                <v-col cols="12">
                  <gg-text-field
                    outlined
                    label="Host name"
                    name="Host name"
                    v-model="editedItem.hostname"
                    v-validate="'required'"
                    :error-messages="errors.collect('Host name')"
                    :suffix="`.${domain.domain}`"
                  ></gg-text-field>
                </v-col>
                <v-col cols="12">
                  <gg-text-field
                    outlined
                    label="IP address"
                    name="IP address"
                    v-validate="'required|ip'"
                    :error-messages="errors.collect('IP address')"
                    v-model="editedItem.ip"
                  ></gg-text-field>
                </v-col>
              </v-row>
            </template>
            <template v-slot:actions>
              <gg-btn secondary @click="closeModal">Cancel</gg-btn>
              <gg-btn primary @click="saveItem" :loading="buttons.save">Save</gg-btn>
            </template>
          </gg-modal>
          <gg-modal :is-active="delete_dialog" @close="closeDeleteModal">
            <template v-slot:toolbar>
              Deleting host record
            </template>
            <template v-slot:body>
              Are you sure you want to delete host record <b>{{ host_for_delete }}.{{ domain.domain }}</b>
            </template>
            <template v-slot:actions>
              <gg-btn secondary @click="closeDeleteModal">Cancel</gg-btn>
              <gg-btn primary @click="hostDelete" :loading="buttons.delete">Delete</gg-btn>
            </template>
          </gg-modal>
        </gg-card-text>
      </gg-card>
    </div>
  </gg-loading>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'NameServersRegistration',
  data: () => ({
    ns_table: {
      headers: [
        { text: 'Hostname', value: 'hostname', sortable: false },
        { text: 'IP address', value: 'ip', sortable: false },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' }
      ]
    },
    dialog: false,
    delete_dialog: false,
    defaultItem: {
      hostname: '',
      ip: ''
    },
    editMode: false,
    editedItem: {
      hostname: '',
      ip: ''
    },
    host_for_delete: '',
    buttons: {
      validate: false,
      delete: false,
      save: false,
    },
    table_loading: false
  }),
  computed: {
    ...mapGetters(['domain', 'domainPopulated', 'pagination'])
  },
  methods: {
    ...mapActions(['getDomain', 'domainNameServer', 'reportError', 'reportSuccess', 'makecall']),
    async hostValidate (host) {
      try {
        this.buttons.validate = true
        const data = {
          hostname: host,
          domain_id: this.domain.id,
          action: 'validate'
        }
        const response = await this.domainNameServer({ ...data })
        this.getDomain({ domain_id: this.domain.id, refresh: true })
        this.reportSuccess(response.resultmsg)

        this.buttons.validate = false
      } catch (e) {
        this.buttons.validate = false
        this.reportError(e)
      }
    },
    async hostEdit (item) {
      this.editedItem = Object.assign({}, item)
      this.editMode = true
      this.dialog = true
    },
    async hostDelete () {
      try {
        this.buttons.delete = true

        const data = {
          hostname: this.host_for_delete,
          domain_id: this.domain.id,
          action: 'delete'
        }

        await this.domainNameServer({ ...data })

        this.buttons.delete = false
        this.closeDeleteModal()
        this.reportSuccess('Nameserver deleted')

        this.table_loading = true
        await this.getDomain({ domain_id: this.domain.id, refresh: true })
        this.table_loading = false
      } catch (e) {
        this.buttons.delete = false
        this.closeDeleteModal()
        this.reportError('Error deleting Nameserver')
      }
    },
    openDeleteModal (host) {
      this.delete_dialog = true
      this.host_for_delete = host
    },
    closeDeleteModal () {
      this.delete_dialog = false
      this.host_for_delete = ''
    },
    async saveItem () {
      try {
        const valid = await this.$validator.validateAll()
        if (!valid) return

        this.buttons.save = true
        const action = this.editMode ? 'update' : 'register'
        const data = {
          action,
          hostname: this.editedItem.hostname,
          ip: this.editedItem.ip,
          domain_id: this.domain.id,
        }

        const response = await this.domainNameServer({ ...data })
        this.reportSuccess(response.resultmsg)

        this.buttons.save = false
        this.closeModal()
        this.table_loading = true
        await this.getDomain({ domain_id: this.domain.id, refresh: true })
        this.table_loading = false
      } catch (e) {
        this.buttons.save = false
        this.closeModal()
        this.reportError(e)
      }
    },
    closeModal () {
      this.dialog = false
      this.editMode = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.$validator.reset()
    }
  },
}
</script>
